import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/products";

export const expectations = {
    // ...example,
    gets(_product, data){
        return axios.get(`${url}/${_product}/expectations`, data).then(result => result.data);
    },
    post(_product, data){
        return axios.post(`${url}/${_product}/expectations`, data).then(result => result.data);
    },
    put(_product, data){
        return axios.put(`${url}/${_product}/expectations/${data._id}`, data).then(result => result.data);
    },
    delete(_product, data){
        return axios.delete(`${url}/${_product}/expectations/${data._id}`).then(result => result.data);
    }
}
